import React from 'react';
import { Application, ApplicationStatus } from "components/JobBoardDetails/types"; 
import ApplicationsListItem from './ApplicationsListItem';
import {
    ItemContainer, 
    TopSection,
    Image,
    Titles,
    Badge, // Assuming Badge might be used, or similar components for status
    CandidateName,
    CandidateExperience,
    StyledSchoolOutlined,
    ViewCandidateButton, // For the "VIEW CANDIDATE >" button
    NewCandidateBadge, ShortlistedCandidateBadge, DeclinedCandidateBadge, // Specific badges
    NoApplicationsMessage,
    ActionsWrapper, // Add import for ActionsWrapper
    NoRatingText // Add import for NoRatingText
} from './ApplicationsList.styles';

// Temporary inline types - these should be defined properly or imported if they exist elsewhere
export type ApplicationViews = "newOrViewed" | "shortlisted" | "hideCandidates";
export interface SortedApplicationsProps {
    newCandidates: Application[];
    shortlistedCandidates: Application[];
    declinedCandidates: Application[];
    viewedCandidates: Application[];
}

interface ApplicationsListProps {
    sortedApplications: SortedApplicationsProps;
    onApplicationClick: (application: Application) => void;
    applicationType: ApplicationViews; 
    disableCardStyle?: boolean;
    jobType?: number; // Add jobType prop
}

const ApplicationsList = ({ sortedApplications, onApplicationClick, applicationType, disableCardStyle, jobType }: ApplicationsListProps) => {
    const {newCandidates, shortlistedCandidates, declinedCandidates, viewedCandidates} = sortedApplications;

    // Helper to render a single application item
    const renderApplicationItem = (application: Application, isNew?: boolean, isShortlisted?: boolean, isHidden?: boolean, isDeclined?: boolean) => {
        // Update the application name to include RDH if needed
        const updatedApplication = jobType === 0 
            ? { ...application, name: `${application.name}, RDH` }
            : application;
        
        return (
            <ApplicationsListItem
                key={application.applicationId}
                application={updatedApplication}
                onApplicationClick={onApplicationClick}
                isNew={isNew}
                isShortlisted={isShortlisted}
                isHidden={isHidden}
                isDeclined={isDeclined}
            />
        );
    };
    
    if (applicationType === 'newOrViewed') {
        return (
            <>
                {newCandidates.map((application: Application) => renderApplicationItem(application, true))}
                {viewedCandidates.map((application: Application) => renderApplicationItem(application))}
                {(newCandidates.length === 0 && viewedCandidates.length === 0) && <NoApplicationsMessage>No new or viewed applications.</NoApplicationsMessage>}
            </>
        );
    } else if (applicationType === 'shortlisted') {
        return (
            <>
                {shortlistedCandidates.map((application: Application) => renderApplicationItem(application, false, true))}
                {shortlistedCandidates.length === 0 && <NoApplicationsMessage>No shortlisted applications.</NoApplicationsMessage>}
            </>
        );
    } else if (applicationType === 'hideCandidates') {
        return (
            <>
                {declinedCandidates.map((application: Application) => renderApplicationItem(application, false, false, true, true))}
                {declinedCandidates.length === 0 && <NoApplicationsMessage>No hidden applications.</NoApplicationsMessage>}
            </>
        );
    }

    return null;
}

export default ApplicationsList;
